export enum ProfileType {
	Personal = "Personal", // user's personal card
	Business = "Business", // user's business card
	EntLimited = "EntLimited", // enterprise (offers limited amount of tokens)
	EntUnlimited = "EntUnlimited", // enterprise (offers unlimited amount that adds up the consumed tokens)
	EntPartner = "EntPartner", // enterprise (offers tokens targeted to a PartnerId)
	Partner = "Partner", // partner to partner access to the content
	Shared = "Shared", // prepaid amount of tokens and shared with many (family)
	Gift = "Gift" // virtual or physical gift cards
}